exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basemaps {\n    padding: 4px;\n}\n.basemaps.closed .basemap {\n    display: none;\n}\n.basemaps.closed .basemap.alt {\n    display: inline-block;\n}\n.basemaps.closed .basemap.alt h4 {\n    display: none;\n}\n\n.basemap {\n    display: inline-block; /* todo: flexbox? */\n    cursor: pointer;\n}\n.basemap.active img {\n    border-color: orange;\n    box-shadow: 2px 2px 4px #000;\n}\n.basemap img {\n    width: 64px;\n    border: 2px solid #FFF;\n    margin: 0 2px;\n    border-radius: 40px;\n    box-shadow: 0 1px 5px rgba(0,0,0,0.65)\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/leaflet-basemaps/L.Control.Basemaps.css
// module id = jmJb
// module chunks = 1